import { buildSiteCatalog, resolveCanonicalSiteIdentity } from './siteIdentity';

const toArray = (value) => (Array.isArray(value) ? value : []);

const toOnlineBool = (value) => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'yes', 'on', 'up', 'online', 'connected'].includes(normalized)) return true;
    if (['0', 'false', 'no', 'off', 'down', 'offline', 'disconnected'].includes(normalized)) return false;
  }
  return false;
};

export const normalizeVoucherNasPayload = (payload) => {
  const source = payload && typeof payload === 'object' ? payload : {};
  const rawItems = Array.isArray(source) ? source : toArray(source.items);
  const siteCatalog = buildSiteCatalog(toArray(source.sites));
  const items = rawItems.map((item) => {
    const row = item && typeof item === 'object' ? item : {};
    const siteIdentity = resolveCanonicalSiteIdentity(row, siteCatalog);
    const routerId = String(row.router_id || row.routerId || row.id || '').trim();
    const nasIdentifier = String(row.nas_identifier || row.nasIdentifier || row.identity || routerId).trim();
    return {
      ...row,
      id: String(row.id || routerId || nasIdentifier).trim(),
      router_id: routerId || null,
      site_id: siteIdentity.site_id,
      site_name: siteIdentity.site_name,
      name: String(row.name || row.router_name || row.label || nasIdentifier || routerId).trim(),
      nas_identifier: nasIdentifier || null,
      vpn_ip: String(row.vpn_ip || row.host || row.mgmt_ip || '').trim() || null,
      service_type: String(row.service_type || row.serviceType || 'hotspot').trim().toLowerCase() || 'hotspot',
      vpn_required: row.vpn_required !== false,
      is_online: toOnlineBool(row.is_online),
    };
  });
  const total = Number.isFinite(Number(source.total)) ? Number(source.total) : items.length;
  return { total, items };
};

export const normalizeFtthTopologyPayload = (payload) => {
  const source = payload && typeof payload === 'object' ? payload : {};
  const siteCatalog = buildSiteCatalog(toArray(source.sites));
  const olts = toArray(source.olts).map((item) => {
    const row = item && typeof item === 'object' ? item : {};
    const siteIdentity = resolveCanonicalSiteIdentity(row, siteCatalog);
    return {
      ...row,
      site_id: siteIdentity.site_id,
      site_name: siteIdentity.site_name,
    };
  });
  const oltsById = new Map(olts.map((item) => [String(item.id || '').trim(), item]));
  const odps = toArray(source.odps).map((item) => {
    const row = item && typeof item === 'object' ? item : {};
    const linkedOlt = oltsById.get(String(row.olt_id || '').trim());
    const siteIdentity = resolveCanonicalSiteIdentity({
      ...row,
      site_id: row.site_id || linkedOlt?.site_id,
      site_name: row.site_name || linkedOlt?.site_name,
      location: row.location || linkedOlt?.location,
      site: row.site || linkedOlt?.site,
    }, siteCatalog);
    return {
      ...row,
      site_id: siteIdentity.site_id,
      site_name: siteIdentity.site_name,
    };
  });
  const odpsById = new Map(odps.map((item) => [String(item.id || '').trim(), item]));
  const customers = toArray(source.customers).map((item) => {
    const row = item && typeof item === 'object' ? item : {};
    const linkedOdpId = row.linked_odp_id || row.odp_id || row.odpId || null;
    const linkedOltId = row.linked_olt_id || row.olt_id || row.oltId || null;
    const linkedRouterId = row.linked_router_id || row.router_id || row.routerId || null;
    const linkedOdp = odpsById.get(String(linkedOdpId || '').trim());
    const linkedOlt = oltsById.get(String(linkedOltId || linkedOdp?.olt_id || '').trim());
    const siteIdentity = resolveCanonicalSiteIdentity({
      ...row,
      site_id: row.site_id || linkedOdp?.site_id || linkedOlt?.site_id,
      site_name: row.site_name || linkedOdp?.site_name || linkedOlt?.site_name,
      location: row.location || linkedOlt?.location,
      site: row.site || linkedOdp?.site || linkedOlt?.site,
    }, siteCatalog);
    return {
      ...row,
      linked_odp_id: linkedOdpId,
      linked_olt_id: linkedOltId,
      linked_router_id: linkedRouterId,
      router_id: row.router_id || linkedRouterId || null,
      site_id: siteIdentity.site_id,
      site_name: siteIdentity.site_name,
    };
  });
  return {
    olts,
    odps,
    customers,
    genieacs: {
      available: Boolean(source?.genieacs?.available),
      updated_at: source?.genieacs?.updated_at || null,
    },
  };
};
